import type { User } from "@/types/auth.type";
import { meApi } from "./me.api";
import { dtoToMe } from "./me.transform";

export const getMe = async (): Promise<User> => {
  const response = await meApi();
  return dtoToMe(response.data);
};
